import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { Team, User } from 'models';
import { TeamUserHelpers } from 'helpers/TeamUserHelpers';

import { useCurrentTeam } from './use-current-team';

export const useCurrentTeamOwners = (): User['id'][] => {
    const team = useCurrentTeam();

    if (!team) {
        return [];
    }

    return getTeamOwners(team);
};

export const getTeamOwners = (team: Team): User['id'][] => {
    return CollectionHelpers.ids(TeamUserHelpers.getOwners(TeamUserHelpers.fromTeam(team)), 'user');
};
